import { useCallback, useEffect, useRef } from "react";
import { history } from "../../utils/History";

const WARNING_MESSAGE = "Hasil generate belum disimpan. Yakin ingin meninggalkan halaman ini?";

const useUnsavedChangesGuard = (active) => {
  const allowNavigationRef = useRef(false);

  const allowNavigation = useCallback(() => {
    allowNavigationRef.current = true;
  }, []);

  useEffect(() => {
    if (!active) return undefined;

    const handleBeforeUnload = (event) => {
      if (allowNavigationRef.current) return;
      event.preventDefault();
      event.returnValue = "";
    };
    const unblock = history.block(() => allowNavigationRef.current ? undefined : WARNING_MESSAGE);
    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      unblock();
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [active]);

  return allowNavigation;
};

export default useUnsavedChangesGuard;

